<template lang="pug">
  div.map-popup.map-popup-relation
    div
      div.tooltip__head
        p.title Информация о связи
        span(@click="close($event)").close.close--small.close--tooltip
      div.tooltip__body
        // div {{fields}}
        div(v-if="fields.start").tooltip__body-item
          span.info.info--grey От:
          span(v-html="fields.start.name").info

        div(v-if="fields.end").tooltip__body-item
          span.info.info--grey До:
          span(v-html="fields.end.name").info

        div(v-if="fields.end").tooltip__body-item
          span.info.info--grey Отправлено отходов тыс. тонн/год:
          span(v-html="transformedGarbageValue").info

        div(v-if="hasCubic").tooltip__body-item
          span.info.info--grey Отправлено отходов куб.м/год:
          span(v-html="garbageValueCubic").info

        div(v-if="fields.end && (fields.end.distance || fields.end.planning_distance)").tooltip__body-item
          span.info.info--grey {{fields.end.planning_distance ? 'Планируемое расстояние' : 'Расстояние'}}, км:
          span.info {{fields.end.planning_distance ? (fields.end.planning_distance / 1000).toFixed(3) : fields.end.distance ? (fields.end.distance / 1000).toFixed(3) : '-' }}
        div.tooltip__head.garbage-items(v-if="loading")
          div.spinner
            div.rect1
            div.rect2
            div.rect3
            div.rect4
            div.rect5
        div.garbage-items
          e-table-inner(
          :styles="{'max-height': '100px'}"
          @loaded="loading = false"
          v-show="garbageItems.data && garbageItems.data.length > 0"
          :enableInnerPagination="false"
          :showFooter="false"
          ref="output"
          :tableId="'output'"
          :itemsEndpoint="garbageEndpoint"
          :showDeleteButton="false"
          )
        div.tooltip__body-item(v-show="!loading && garbageItems.data && garbageItems.data.length === 0")
          span.info.info--grey Нет данных по движению переданных отходов
      div.tooltip__foot
</template>

<script>
  import baseMapPopupMixin            from './base-map-popup-mixin.js'
  import {map}                        from '@/api/api-endpoints'
  import year                         from '../../utils/year'

  export default {
    mixins: [baseMapPopupMixin],
    name: 'map-popup-relation',
    data () {
      this.closeCallback = null
      return {
        loading: true,
        fields: {},
      }
    },
    computed: {
      garbageItems () {
        return this.$sharedServices.store.getters.readUrlEndpoint(this.garbageEndpoint) || {data: [], _meta: {}}
      },
      garbageValue () {
        if (this.fields.end) {
          if (this.fields.end.hasOwnProperty('garbage_value')) {
            return this.isEmptyI(this.fields.end.garbage_value)
          } else if (this.fields.end.hasOwnProperty('total')) {
            return this.isEmptyI(this.fields.end.total)
          }
        }
        return ' - '
      },
      hasCubic () {
        if (this.fields.end) {
          return this.fields.end.hasOwnProperty('garbage_value_cubic') || this.fields.end.hasOwnProperty('total_cubic')
        }
        return false
      },
      garbageValueCubic () {
        if (this.fields.end) {
          if (this.fields.end.hasOwnProperty('garbage_value_cubic')) {
            return this.isEmptyI(parseInt(this.fields.end.garbage_value_cubic))
          } else if (this.fields.end.hasOwnProperty('total_cubic')) {
            return this.isEmptyI(parseInt(this.fields.end.total_cubic))
          }
        }
        return ' - '
      },
      transformedGarbageValue () {
        return this.isEmptyI(parseInt(this.garbageValue))
      },
      year() {
        return this.$sharedServices.router.currentRoute.query && this.$sharedServices.router.currentRoute.query.year
          ? this.$sharedServices.router.currentRoute.query.year : year.getCurrentYear()
      },
      garbageEndpoint() {
        let query = {
          sourceId: this.fields.start.id,
          destinationId: this.fields.end.id,
          year: this.year
        }
        if (this.paginationQuery) {
          query = Object.assign(query, this.paginationQuery)
        }
        return this.setEndpoint(query)
      }
    },
    methods: {
      setEndpoint(query) {
        let result = ''
        switch(this.fields.relationType) {
          case 'settlement-object':
            result = map.outputSettlement(query)
            break
          case 'garbage_source-object':
            result = map.outputGarbageSource(query)
            break
          case 'object-object':
            result = map.outputObject(query)
            break
        }
        return result
      },
      isEmptyI(value){
        return value || ' - '
      },
      injectConf (options) {
        let {model, closeCallback} = options
        this.closeCallback = closeCallback
        this.fields = Object.assign({}, model || {})
        this.registerVueInMap()
      },
      close ($event) {
        this.closeCallback($event)
      },
    },
    mounted() {
      this.$refs.output.updateTable()
    }
  }
</script>
<style scoped>
</style>
